<template>
  <div id="page-month-detail">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="8em"
    >
      <el-row>
        <el-form-item prop="businessLine" label="业务线" required>
          <filter-business-line :value.sync="searchForm.businessLine" :ops="false" required />
        </el-form-item>
        <el-form-item prop="regionId" label="Region">
          <filter-region-nation v-if="isJobEpiboly" :value.sync="searchForm.regionIdJobEpiboly" />
          <filter-businessline-region
            v-else
            :value.sync="searchForm.regionId"
            :businessLine="searchForm.businessLine"
          />
        </el-form-item>
        <el-form-item prop="supplierId" label="合作商" required>
          <filter-businessline-partner
            :value.sync="searchForm.supplierId"
            :businessLine="searchForm.businessLine"
            required
          />
        </el-form-item>
        <el-form-item prop="staffType" label="账单类别" required>
          <filter-worker-type :value.sync="searchForm.staffType" required />
        </el-form-item>
        <el-form-item prop="orderStatus" label="账单状态">
          <el-select filterable clearable v-model="searchForm.orderStatus">
            <el-option
              v-for="item in processStatusList"
              :label="item.statusName"
              :value="item.statusId"
              :key="item.statusId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="账期" required>
          <el-date-picker
            v-model="billDate"
            :clearable="false"
            type="monthrange"
            value-format="yyyy-MM"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="getDataList(true)">查询</el-button>
          <el-button @click="$refs.searchForm.resetFields()">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row class="align-r margin-b-10">
      <el-button @click="exportUrl" :loading="isDownLoading">下载列表</el-button>
    </el-row>
    <!-- 列表 -->
    <el-table stripe v-loading="isQueryLoading" :data="dataList">
      <el-table-column
        v-for="(item, index) in tablePropsList"
        :key="index"
        :fixed="item.props === 'handle' ? 'right' : false"
        :label="item.label"
        :width="item.width || ''"
      >
        <template slot="header" v-if="item.props === 'otherMoney'">
          <span>{{ item.label }}</span>
          <el-tooltip effect="dark" placement="top-end">
            <div slot="content">
              <div>其他费用包含补发补扣等</div>
              <div>津贴费用，即固定成本费用。</div>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <el-button type="text" @click="getDetailMes(scope.row)" v-if="item.props === 'handle'"
            >详情</el-button
          >
          <span v-else>{{ scope.row[item.props] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>

    <el-dialog
      title="账单详情"
      :visible.sync="orderDetailVisible"
      width="90%"
      :close-on-click-modal="false"
    >
      <el-row class="bill-num" :gutter="5">
        <el-col :span="6">
          <h3>对账单号：{{ detailConfigObj.settlementOrderNo || '' }}</h3>
        </el-col>
        <el-col :span="4" :offset="14" v-if="+detailConfigObj.orderStatus === 1">
          <el-button type="primary" @click="changeBillStatus((type = 'refuse'))" class="align-r"
            >驳回</el-button
          >
          <el-button type="primary" @click="changeBillStatus((type = 'confirm'))"
            >确认账单</el-button
          >
        </el-col>
      </el-row>
      <el-divider />
      <div class="step-wrapper">
        <el-steps :space="200" :active="stepStatus" finish-status="success" align-center>
          <el-step title="供应商确认账单数据" />
          <el-step title="运营审核" />
          <el-step title="付款" />
          <el-step title="发票录入&验票" />
          <el-step title="完成" />
        </el-steps>
      </div>
      <el-divider />
      <div class="detail-table">
        <el-table
          stripe
          v-loading="isQueryLoading"
          :data="detailDataList"
          style="display: inline-block"
        >
          <el-table-column
            v-for="(item, index) in detailTableProps"
            :key="index"
            :label="item.label"
            :width="item.width || ''"
          >
            <template slot="header" v-if="item.props === 'otherMoney'">
              <span>{{ item.label }}</span>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">
                  <div>其他费用包含补发补扣等</div>
                  <div>津贴费用，即固定成本费用。</div>
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row[item.props] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-divider />

        <article class="ui-danger">
          说明：账单汇总的工资总计=所有人的总计之和，账单汇总的员工费用=所有非负数的员工费用之和，汇总的供应商费用=汇总的工资总计-汇总的员工费用。
        </article>
        <el-divider />
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="人员费用列表" name="expense">
          <div class="flex margin-b-10">
            <div class="flex-item">
              <el-input
                :maxlength="32"
                placeholder="按姓名/手机号搜索"
                clearable
                class="tab-input"
                v-model="nameOrMobile"
              >
                <el-button slot="append" icon="el-icon-search" @click="searchByUser" />
              </el-input>
            </div>
            <div class="flex-item align-r">
              <!-- <el-button type="primary" @click="handleBatchPrice" v-if="isShowHandleBtn"
                >批量分配</el-button
              >
              <el-button type="primary" @click="openUploadDialog" v-if="isShowHandleBtn"
                >上传Excel分配金额</el-button
              > -->
              <el-button
                @click="handlePersonDownLoad"
                :disabled="!detailPersonList.length || isDownLoadingDetail"
                >下载列表</el-button
              >
              <el-button
                @click="handleCostDetailDownLoad"
                :disabled="!detailPersonList.length || isDownLoadingDetail"
                >下载费用明细</el-button
              >
            </div>
          </div>

          <el-table
            v-loading="isQueryPersonLoading"
            :row-class-name="tableRowClassName"
            :data="detailPersonList"
          >
            <el-table-column v-for="item in detailPersonProp" :key="item.props" :label="item.label">
              <template slot="header" v-if="item.props === 'otherMoney'">
                <span>{{ item.label }}</span>
                <el-tooltip effect="dark" placement="top-end">
                  <div slot="content">
                    <div>其他费用包含补发补扣等</div>
                    <div>津贴费用，即固定成本费用。</div>
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div v-if="item.props === 'personMoney'" class="person-cost">
                  <span v-if="!scope.row.isEdit">{{ scope.row[item.props] }}</span>
                  <el-input-number
                    v-model="scope.row.personMoney"
                    :precision="2"
                    class="input-width"
                    size="small"
                    :controls="false"
                    v-else
                  />
                </div>
                <span v-else>{{ scope.row[item.props] }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="编辑" width="150" v-if="isShowHandleBtn">
              <template slot-scope="scope">
                <el-button type="text" @click="handleDistribute(scope.row)" v-if="!scope.row.isEdit"
                  >分配金额</el-button
                >
                <div v-else>
                  <el-button
                    type="text"
                    @click="handlePriceSave(scope.row)"
                    :loading="isSavingPrice"
                    >保存</el-button
                  >
                  <el-button type="text" @click="handlePriceCancel">取消</el-button>
                </div>
              </template>
            </el-table-column> -->
          </el-table>

          <div class="paging-wrapper" v-if="totalPages2 > 1">
            <el-pagination
              background
              @current-change="handlePageNoChange2"
              :current-page.sync="pageNo2"
              :page-size="pageSize2"
              layout="prev, pager, next, slot, jumper"
              :total="totalAmount2"
            >
              <span class="page-indicator"
                ><em>{{ pageNo2 }}</em
                >/{{ totalPages2 }}</span
              >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="发票信息(上传发票)" name="invoce">
          <invoice-info ref="invoiceInfo" :isModalShow="false" :invoice-enable="canVoiceBtn" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog title="批量分配" :visible.sync="batchDialogVisible" width="80%">
      <el-row :gutter="5">
        <el-col span="4" class="margin-t-10">员工费用 = 员工工资总计</el-col>
        <el-col span="4">
          <el-select v-model="batchForm.type" size="small">
            <el-option
              v-for="item in batchTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-col>
        <el-col span="5">
          <el-input-number v-model="batchForm.value" :precision="2" :controls="false" :min="0" />
        </el-col>
      </el-row>

      <div slot="footer">
        <el-button @click="batchDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBatchConfig" :loading="isSavingBatch">
          保存
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="上传Excel分配金额" :visible.sync="uploadDialogVisible" width="60%">
      <el-row :gutter="2">
        <el-col :span="3" class="margin-t-10">选择文件</el-col>
        <el-col :span="10">
          <el-upload
            ref="upload"
            action=""
            :multiple="false"
            :file-list="uploadDistributeList"
            :on-change="onFileChange"
            :on-remove="onFileRemoved"
            accept=".xls, .xlsx"
            :auto-upload="false"
          >
            <el-button slot="trigger"> 点击选择文件 </el-button>
          </el-upload>
        </el-col>
        <el-col :offset="3">
          <div class="ui-info margin-t-10">
            注：每次只能上传一个 .xls 或 .xlsx 文件，且不超过10MB
          </div>
        </el-col>
      </el-row>
      <div class="info-area ui-mt-20">
        <span>
          上传规则说明：Excel必须包含此业务线，供应商，账期，region/城市下的所有人员的员工费用，系统以最新上传的Excel为准，会将之前设置的员工费用全部删除。
        </span>
        <el-link
          type="danger"
          class="download-temp"
          :underline="false"
          href="https://s3plus.sankuai.com/v1/mss_217611ce09cf41e682ea066ca826ce67/small-file/%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF2020-12-24350e84a9c2e5433a93b536109dabccd2.xlsx"
        >
          点击下载上传模版
        </el-link>
      </div>

      <div slot="footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveUploadFile" :loading="isSavingUpload">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isNumber, dateFormat } from '@/utils'
import supplierToPerson from '@/mixins/supplierToPerson'
import filtersFormatDate from '@/mixins/filtersFormatDate'
import pagination from '@/mixins/pagination'
import pagination2 from '@/mixins/pagination2'
import invoiceInfo from './invoice-info.vue'

const batchTemp = {
  type: 0,
  value: '',
}

const maxSize = 1024 * 1024 * 10

export default {
  mixins: [supplierToPerson, filtersFormatDate, pagination, pagination2],

  components: {
    invoiceInfo,
  },

  data() {
    this.tablePropsTemp = [
      {
        label: '账单ID',
        props: 'id',
      },
      {
        label: '结算单编号',
        props: 'settlementOrderNo',
        width: '150px',
      },
      {
        label: '业务线',
        props: 'businessLineName',
      },
      {
        label: '账期',
        props: 'accountPeriod',
      },
      {
        label: '供应商全称',
        props: 'supplierName',
        width: '160px',
      },
      {
        label: 'region',
        props: 'regionIdName',
      },
      {
        label: '账单类别',
        props: 'staffTypeName',
      },
      {
        label: '计件工资',
        props: 'workMoney',
      },
      {
        label: '包天工资',
        props: 'dayMoney',
        width: '100px',
      },
      {
        label: '包时工资',
        props: 'timeMoney',
        width: '100px',
      },
      {
        label: '其他费用',
        props: 'otherMoney',
      },
      {
        label: '工资总计',
        props: 'money',
      },
      {
        label: '员工费用',
        props: 'personMoney',
      },
      {
        label: '供应商费用',
        props: 'supplierMoney',
      },
      {
        label: '结算状态',
        props: 'orderStatusName',
      },
      {
        label: '操作',
        props: 'handle',
      },
    ]

    this.personPropList = [
      {
        label: '业务线',
        props: 'businessLineName',
      },
      {
        label: 'region',
        props: 'regionIdName',
      },
      {
        label: '员工姓名',
        props: 'userName',
      },
      {
        label: '手机号',
        props: 'phoneNo',
      },
      {
        label: '工种',
        props: 'workTypeNames',
      },
      {
        label: '结费方式',
        props: 'staffTypeName',
      },
      {
        label: '计件工资',
        props: 'workMoney',
      },
      {
        label: '包天工资',
        props: 'dayMoney',
      },
      {
        label: '包时工资',
        props: 'timeMoney',
        width: '100px',
      },
      {
        label: '其他费用',
        props: 'otherMoney',
      },
      {
        label: '工资总计',
        props: 'money',
      },
      {
        label: '员工费用',
        props: 'personMoney',
      },
      {
        label: '供应商费用',
        props: 'supplierMoney',
      },
    ]

    this.outterPersonPropList = [
      {
        label: '业务线',
        props: 'businessLineName',
      },
      {
        label: '发薪方式',
        props: 'settlementType',
      },
      {
        label: 'uid',
        props: 'userId',
      },
      {
        label: 'region',
        props: 'regionIdName',
      },
      {
        label: '员工姓名',
        props: 'userName',
      },
      {
        label: '手机号',
        props: 'phoneNo',
      },
      {
        label: '职位',
        props: 'jobTypeName',
      },
      {
        label: '工种',
        props: 'workTypeNames',
      },
      {
        label: '招聘来源',
        props: 'humanResource',
      },
      {
        label: '合同类型',
        props: 'contractTypeName',
      },
      {
        label: '总计',
        props: 'money',
      },
      {
        label: '供应商费用',
        props: 'supplierMoney',
      },
      {
        label: '员工费用',
        props: 'personMoney',
      },
    ]

    this.batchTypeList = [
      {
        label: 'X（乘）',
        value: 0,
      },
      {
        label: '一（减）',
        value: 1,
      },
    ]

    return {
      // 请求列表
      uploadDistributeList: [],
      tablePropsList: JSON.parse(JSON.stringify(this.tablePropsTemp)),
      detailConfigObj: {},
      isQueryLoading: false,
      uploadDialogVisible: false,
      isUploading: false,
      isDownLoading: false,
      isDownLoadingDetail: false,
      batchDialogVisible: false,
      orderDetailVisible: false,
      isSavingUpload: false,
      activeTab: 'expense',
      // 搜索条件
      searchForm: {
        businessLine: 1203,
        regionId: '',
        regionIdJobEpiboly: '0',
        supplierId: '',
        orderStatus: '',
        staffType: '',
      },
      billDate: [dateFormat(new Date(), 'yyyy-MM'), dateFormat(new Date(), 'yyyy-MM')],
      pageNo: 1,
      pageSize: 20,
      pageSize2: 10,
      totalAmount: 0,
      // 搜索结果
      dataList: [],
      detailPersonList: [],
      detailPersonProp: [],
      selectCityList: [],
      supplierNewList: [],
      batchForm: JSON.parse(JSON.stringify(batchTemp)),
      pickerOptions: {
        disabledDate(time) {
          const timeSelected = time.getTime()
          const DAY = 86400000
          return timeSelected > Date.now() || timeSelected < Date.now() - 6 * DAY
        },
      },
      detailDataList: [],
      // 供应商核对平台
      isSupplierPlatform: true,
      businessType: '',
      isQueryPersonLoading: false,
      personList: [],
      nameOrMobile: '',
      processStatusList: [],
      isSavingBatch: false,
      isJobEpiboly: false,
    }
  },

  computed: {
    /* 详情列表数据 */
    detailTableProps() {
      return this.tablePropsList.filter(item => {
        return item.props !== 'handle'
      })
    },

    /* 按钮是否展示 */
    isShowHandleBtn() {
      return this.detailConfigObj.orderStatus === 1 && this.detailConfigObj.staffType === 1
    },

    /* 发票操作按钮可用 */
    canVoiceBtn() {
      return this.detailConfigObj.orderStatus === 50
    },

    /* step 状态 */
    stepStatus() {
      const num = +this.detailConfigObj.orderStatus
      let res = ''
      // 统一待确认
      if (num === 10) return (res = 2)
      if (num <= 30) {
        res = 1
      } else {
        res = (num - 20) / 10
      }
      return res
    },

    /* 城市 账单联动 */
    // isDisabledCity() {
    //   return !isNumber(this.searchForm.staffType)
    // },
  },

  watch: {
    // 账单类型
    'searchForm.staffType'(val) {
      this.isJobEpiboly = val === 0
      this.dataList = []
      this.pageNo = 1
      this.totalAmount = 0
      if (this.isJobEpiboly) {
        const tmpList = [
          'cityName',
          'adjustMoney',
          'workMoney',
          'dayMoney',
          'otherMoney',
          'timeMoney',
        ]
        this.tablePropsList = this.tablePropsTemp.filter(item => {
          return tmpList.indexOf(item.props) < 0
        })
      } else {
        this.tablePropsList = JSON.parse(JSON.stringify(this.tablePropsTemp))
      }
    },
    'detailConfigObj.staffType'(val) {
      this.detailPersonProp = val === 1 ? this.personPropList : this.outterPersonPropList
    },
    'detailConfigObj.businessLine'(val) {
      const isBike = val === 1204
      this.detailPersonProp = this.detailPersonProp.map(item => {
        if (item.props === 'workTypeNames') {
          return {
            label: isBike ? '业务类型' : '工种',
            props: 'workTypeNames',
          }
        } else {
          return item
        }
      })
    },
    orderDetailVisible(val) {
      if (!val) {
        this.getDataList()
      }
    },
  },

  created() {
    this.initPagination('getDataList', false)
    this.initPagination2('getDeTailPersonList', false)
    this.getProcessStatusList()
  },

  methods: {
    /* 行样式 */
    tableRowClassName({ row }) {
      if (row.personMoney < 0) {
        return 'ui-danger'
      }
    },

    /* 价格修改取消 */
    handlePriceCancel() {
      // rowObj.isEdit = false
      this.getDeTailPersonList(this.detailConfigObj)
    },

    /* 导出费用详情 */
    handleCostDetailDownLoad() {
      const tmpObj = this.detailConfigObj || {}
      const params = {
        month: tmpObj.accountPeriod,
        businessLine: tmpObj.businessLine,
        supplier: tmpObj.supplierId,
        personType: tmpObj.staffType,
        stationCityCode: tmpObj.staffType === 0 ? '' : tmpObj.regionId,
      }
      this.fetch
        .get('exportSwitch', {
          params: {
            personType: params.personType,
          },
        })
        .then(res => {
          if (res.data) this.exportOrderDataDetail(params)
          else this.exportHrisStatis(params)
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },

    exportOrderDataDetail(params) {
      this.isDownLoadingDetail = true
      this.fetch
        .get('exportOrderDataDetail', {
          params,
        })
        .then(res => {
          this.$message.success(res.message)
        })
        .finally(() => {
          this.isDownLoadingDetail = false
        })
    },

    exportHrisStatis(params) {
      this.isDownLoadingDetail = true
      this.fetch
        .get('hrisStatisExport', {
          params,
        })
        .then(res => {
          this.isDownLoadingDetail = false
          if (res.data) {
            window.downloadFile(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isDownLoadingDetail = false
        })
    },

    /* 发票信息 */
    getInvoiceInfo(id = '') {
      this.$refs.invoiceInfo.initFetch({
        orderId: this.detailConfigObj.settlementOrderNo || id,
      })
    },

    /* 生成结算单 */
    generateCostOrder(obj = {}) {
      return new Promise((resolve, reject) => {
        const params = {
          accountPeriod: obj.accountPeriod,
          regionId: obj.regionId,
          supplierId: obj.supplierId,
          staffType: obj.staffType,
          supplierName: obj.supplierName,
          businessLine: obj.businessLine,
        }

        const formData = new FormData()
        Object.keys(params).forEach(item => {
          formData.append(item, params[item])
        })
        this.isQueryLoading = true
        this.fetch
          .post('generateCostOrder', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(res => {
            this.isQueryLoading = false
            resolve(res.data)
          })
          .catch(() => {
            this.isQueryLoading = false
            reject()
          })
      })
    },

    /* 保存上传 */
    saveUploadFile() {
      const params = {
        file: this.uploadFile && this.uploadFile.raw,
        settlementOrderNo: this.detailConfigObj.settlementOrderNo,
      }
      if (!params.file) {
        return this.$message.error('请选择文件')
      }

      const formData = new FormData()
      Object.keys(params).forEach(item => {
        formData.append(item, params[item])
      })
      this.isSavingUpload = true
      this.fetch
        .post('importDistrubteFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.isSavingUpload = false
          this.$message.success('导入成功')
          this.getDeTailPersonList(this.detailConfigObj, true)
          this.uploadDialogVisible = false
        })
        .catch(() => {
          this.isSavingUpload = false
        })
    },

    /* 分配金额 */
    handleDistribute(rowObj = {}) {
      this.$set(rowObj, 'isEdit', true)
    },

    /* 分配金额保存 */
    handlePriceSave(rowObj = {}) {
      const params = {
        phoneNo: rowObj.phoneNo,
        settlementOrderNo: this.detailConfigObj.settlementOrderNo,
        personMoney: rowObj.personMoney,
      }

      const formData = new FormData()
      Object.keys(params).forEach(item => {
        formData.append(item, params[item])
      })
      this.isSavingPrice = true
      this.fetch
        .post('savePersonPrice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.isSavingPrice = false
          rowObj.isEdit = false
          this.getDataList()
          this.getDeTailPersonList(this.detailConfigObj, true)
        })
        .catch(() => {
          this.isSavingPrice = false
        })
    },

    /* 获取详情人员账单列表 */
    getDeTailPersonList(obj = {}, status = false) {
      const params = {
        accountPeriod: obj.accountPeriod || this.detailConfigObj.accountPeriod,
        regionId: obj.regionId || this.detailConfigObj.regionId,
        supplierId: obj.supplierId || this.detailConfigObj.supplierId,
        staffType: obj.staffType || this.detailConfigObj.staffType,
        businessLine: obj.businessLine || this.detailConfigObj.businessLine,
        searchInfo: this.nameOrMobile,
        pageNo: status ? 1 : this.pageNo2,
        pageSize: 10,
      }
      const formData = new FormData()
      Object.keys(params).forEach(item => {
        formData.append(item, params[item])
      })
      this.isQueryPersonLoading = true
      this.fetch
        .post('getDetailPersonList', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          this.isQueryPersonLoading = false
          this.detailPersonList = res.data || []
          this.totalAmount2 = res.recordsTotal || 0
        })
        .catch(() => {
          this.detailPersonList = []
          this.totalAmount2 = 0
          this.isQueryPersonLoading = false
        })
    },
    /* 按人员信息查询 */
    searchByUser() {
      this.getDeTailPersonList(this.detailConfigObj)
    },

    /* 批量分配 */
    handleBatchPrice() {
      this.batchDialogVisible = true
      this.batchForm = JSON.parse(JSON.stringify(batchTemp))
    },

    /* 上传弹窗 */
    openUploadDialog() {
      this.uploadDialogVisible = true
      this.uploadDistributeList = []
    },

    /* 保存批量方案 */
    saveBatchConfig() {
      // 校验规则
      const params = {
        ...this.batchForm,
        settlementOrderNo: this.detailConfigObj.settlementOrderNo,
      }
      if (params.type === 0 && params.value > 1) {
        // 乘法
        return this.$message.error('如果选择乘，输入的数值必须是小于等于1的正数')
      }
      const formData = new FormData()
      Object.keys(params).forEach(item => {
        formData.append(item, params[item])
      })
      this.isSavingBatch = true
      this.fetch
        .post('savePriceBatch', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.$message.success('操作成功')
          this.isSavingBatch = false
          this.batchDialogVisible = false
          // 更新人员列表
          this.getDeTailPersonList(this.detailConfigObj, true)
        })
        .catch(() => {
          this.isSavingBatch = false
        })
    },
    /* 人员列表导出 */
    handlePersonDownLoad() {
      const params = {
        accountPeriod: this.detailConfigObj.accountPeriod,
        regionId: this.detailConfigObj.regionId,
        businessLine: this.detailConfigObj.businessLine,
        supplierId: this.detailConfigObj.supplierId,
        searchInfo: this.nameOrMobile,
        staffType: this.detailConfigObj.staffType,
      }
      this.isDownLoadingDetail = true
      this.fetch
        .get('exportPersonDataList', {
          params,
        })
        .then(res => {
          this.isDownLoadingDetail = false
          if (res.data) {
            window.open(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isDownLoadingDetail = false
        })
    },

    onFileChange(file, fileList = []) {
      if (file.size > maxSize) {
        fileList.pop()
        return this.$message.error('文件不可超过10M')
      }
      if (fileList.length > 1) {
        fileList.pop()
        return this.$message.error('仅上传一个文件')
      }
      this.uploadFile = file
    },

    onFileRemoved() {
      this.uploadFile = ''
    },

    /* 驳回 | 确认账单 */
    changeBillStatus(type = '') {
      let str = ''
      let auditType = 1
      if (type === 'refuse') {
        str =
          this.detailConfigObj.staffType === 1
            ? '驳回后需要运营在HRIS重新同步账单，并且已经分配的金额将清空，请确认是否驳回?'
            : '驳回后需要运营在HRIS重新同步账单，请确认是否驳回'
        auditType = 2
      } else {
        str = '账单确认后，会将账单封账，运营、供应商都不能再调整金额，是否确认账单?'
        auditType = 1
      }
      const params = {
        auditType,
        settlementOrderNo: this.detailConfigObj.settlementOrderNo,
      }
      const formData = new FormData()
      Object.keys(params).forEach(item => {
        formData.append(item, params[item])
      })
      this.$confirm(str, '提示', {
        type: 'warning',
      })
        .then(() => {
          this.fetch
            .post('changeOrderStatus', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(() => {
              this.$message.success('操作成功')
              this.orderDetailVisible = false
              this.getDataList()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },

    /* 展示详情 */
    async getDetailMes(detailObj = {}) {
      this.orderDetailVisible = true
      this.detailConfigObj = JSON.parse(JSON.stringify(detailObj))
      // this.detailDataList = [{ ...this.detailConfigObj }]

      await this.$nextTick() // 让dialog渲染完成后再继续

      // 获取详情数据
      // 兼容业务，row数据有settlementOrderNo时直接使用
      const { settlementOrderNo } = detailObj
      if (settlementOrderNo) {
        this.detailMesHelper(settlementOrderNo)
      } else {
        this.generateCostOrder(this.detailConfigObj)
          .then(res => {
            // 更新列表账单号
            this.detailMesHelper(res)
          })
          .catch(() => {})
      }
    },

    detailMesHelper(settlementOrderNo) {
      this.detailConfigObj.settlementOrderNo = settlementOrderNo || ''
      this.detailDataList = [{ ...this.detailConfigObj }]
      // 获取详情人员列表
      this.getDeTailPersonList(this.detailConfigObj, true)
      // 获取发票信息
      this.getInvoiceInfo(settlementOrderNo)
    },

    /* 获取状态 */
    getProcessStatusList() {
      this.fetch
        .get('supplierOrderProcessStatus')
        .then(res => {
          const { statusList = [] } = res.data
          this.processStatusList = statusList
        })
        .catch(() => {})
    },

    /* 获取结费列表 */
    getDataList(init) {
      if (init) {
        this.pageNo = 1
      }

      const params = {
        ...this.searchForm,
        accountPeriodStart: this.billDate && this.billDate[0],
        accountPeriodEnd: this.billDate && this.billDate[1],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      if (this.isJobEpiboly) {
        params.regionId = params.regionIdJobEpiboly
      }
      if (!isNumber(params.staffType)) {
        return this.$message.error('请选择账单类型')
      }
      if (!params.supplierId) {
        return this.$message.error('请选择供应商')
      }
      if (!params.accountPeriodStart) {
        return this.$message.error('请选择查询账期')
      }
      const formData = new FormData()
      Object.keys(params).forEach(item => {
        formData.append(item, params[item])
      })

      this.isQueryLoading = true
      this.fetch
        .post('getSupplierCostList', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          this.isQueryLoading = false
          this.totalAmount = +res.recordsTotal
          this.dataList = res.data
        })
        .catch(() => {
          this.dataList = []
          this.totalAmount = 0
          this.isQueryLoading = false
        })
    },

    /* 导出列表 */
    exportUrl() {
      const params = {
        ...this.searchForm,
        businessLine: this.searchForm.businessLine,
        accountPeriodStart: this.billDate && this.billDate[0],
        accountPeriodEnd: this.billDate && this.billDate[1],
      }
      if (this.isJobEpiboly) {
        params.regionId = params.regionIdJobEpiboly
      }
      this.isDownLoading = true
      this.fetch
        .get('exportOrderDataList', {
          params,
        })
        .then(res => {
          this.isDownLoading = false
          if (res.data) {
            window.open(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isDownLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
#page-month-detail {
  .filter-item-supplier {
    min-width: 300px;
  }
  .tab-input {
    &.el-input {
      width: 225px;
    }
  }
  .person-cost {
    .el-input {
      width: 80px;
    }
  }
  .el-divider--horizontal {
    margin: 15px 0;
  }
  .step-wrapper {
    margin-left: 10%;
  }
  .bill-num {
    margin-top: -20px;
  }

  .upload-tip {
    margin-top: 20px;
    font-size: 13px;
    color: #999;
  }

  .computed-amount {
    font-size: 28px;
  }

  .price-id-info {
    color: #999;
    line-height: 1.5;
    .el-row {
      margin-bottom: 0;
    }
  }
  .info-area {
    .download-temp {
      display: block;
      margin-top: 5px;
    }
  }

  .content-block {
    font-size: 12px;
    margin-bottom: 10px;
    border: 1px solid #ececec;
  }

  .audit-block {
    border: 1px solid #ececec;
    padding: 10px;
  }

  .button-block {
    margin-top: 10px;
  }

  section {
    padding: 10px;
    border-top: 1px solid #ececec;
  }

  .head-info {
    margin-top: 10px;
    padding: 0px 10px;
  }

  .item-title {
    font-weight: bold;
  }

  .content-detail {
    padding: 0px 15px;
  }

  .reconsider-block {
    .el-form-item__label {
      font-weight: 600;
    }
    .el-form-item {
      margin-bottom: 5px;
    }
  }
}
</style>
